/**
 * Removes stray » and « characters from all h1-h6 elements on the page.
 * Only touches text nodes so nested markup (links, spans, etc.) is preserved.
 */
export function stripGuillemets() {
  document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/[»«”„]/.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(/[»«”„]/g, "");
      }
    }
  });
}
